<script>
import i18n from '@shared/module/i18n'
import branches from '@/static/branches.js'

export default {
  methods: {
    isArray(a) {
      return (!!a) && (a.constructor === Array)
    },
    getBranchById(id) {
      return this.getBranches().filter(x => x.id === id)[0]
    },
    getBranches() {
      const locale = i18n.locale
      const data = branches.branches()
      if (this.isArray(data)) {
        return data
      } else {
        return data[locale] || data.en
      }
    }
  }
}
</script>
